// Metadata is independent of app.js so plugins can read it before Vue starts.
export const CLIENT = process.env.MIX_APP_CLIENT || "default";
export const clientData = require(`./${CLIENT}/data.json`);
